export {layerManager, getLayersCount} from './LayerManager';
export type {LayerConfig, LayerCloseReason} from './LayerManager';
export {useLayer} from './useLayer';
export type {LayerProps} from './useLayer';
